var map = {
	"./内容页/中国精神-丝路精神内容页.png": "ec41",
	"./内容页/中国精神-企业家精神内容页.png": "c051",
	"./内容页/中国精神-伟大抗战精神内容页.png": "4af5",
	"./内容页/中国精神-塞罕坝精神内容页.png": "6f31",
	"./内容页/中国精神-大庆精神内容页.png": "38f1",
	"./内容页/中国精神-女排精神内容页.png": "f387",
	"./内容页/中国精神-延安精神内容页.png": "dc9c",
	"./内容页/中国精神-抗洪精神内容页.png": "beca",
	"./内容页/中国精神-抗震救灾精神内容页.png": "144f",
	"./内容页/中国精神-探月精神内容页.png": "087f",
	"./内容页/中国精神-改革开放精神内容页.png": "5326",
	"./内容页/中国精神-新时代北斗精神内容页.png": "8b1ac",
	"./内容页/中国精神-焦裕禄精神内容页.png": "2f2e",
	"./内容页/中国精神-王杰精神内容页.png": "d4b4",
	"./内容页/中国精神-科学家精神内容页.png": "eb3d",
	"./内容页/中国精神-红岩精神内容页.png": "d525",
	"./内容页/中国精神-红旗渠精神内容页.png": "6a9a",
	"./内容页/中国精神-西柏坡精神内容页.png": "4709",
	"./内容页/中国精神-载人航天精神内容页.png": "5391",
	"./内容页/中国精神-遵义会议精神内容页.png": "ad91",
	"./点击查看360°全景.png": "af45",
	"./点击查看交互式媒体.png": "c444",
	"./点击查看交互式对话.png": "ba41",
	"./点击查看数字博物馆.png": "a5b2",
	"./点击查看精神印记.png": "ad92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0a8";